/* eslint-disable sort-imports */
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import debounce from '../utils/debounce';

class UserJourneyItem {
  constructor(block) {
    this.block = block;

    this.selectors = {
      container: '.b-user-journey__container',
      bbarButtonGoBack: '.b-user-journey__bbar-button--go-back',
      bbarButtonPrev: '.b-user-journey__bbar-button--prev',
      bbarButtonNext: '.b-user-journey__bbar-button--next',
      steps: '.b-user-journey__steps',
      step: '.b-user-journey__step',
      navigation: '.b-user-journey__navigation',
      navigationItems: '.b-user-journey__navigation-items',
      navigationItem: '.b-user-journey__navigation-item',
      navigationItemReal: '.b-user-journey__navigation-item-real',
      navigationItemLast: '.b-user-journey__navigation-item-last',
      navigationItemTitle: '.b-user-journey__navigation-item-title',
      navigationMobileTitle: '.b-user-journey__navigation-mobile-title',
      navigationTbarButtonNext: '.b-user-journey__navigation-tbar-button--next',
      navigationTbarButtonPrev: '.b-user-journey__navigation-tbar-button--prev',
    };

    this.classes = {
      stepHidden: 'b-user-journey__step--hidden',
      navigationVisible: 'b-user-journey__navigation--visible',
      navigationItemActive: 'b-user-journey__navigation-item--active',
      navigationItemLastVisible: 'b-user-journey__navigation-item-last--visible',
      navigationTbarButtonHidden: 'b-user-journey__navigation-tbar-button--hidden',
      navigationBbarButtonHidden: 'b-user-journey__bbar-button--hidden',
    };

    this.navigationSlider = false;
    this.currentStep = false;

    this.bootstrap();
  }

  bootstrap() {
    const container = this.block.querySelector(this.selectors.container);
    const bbarButtonGoBack = document.querySelector(this.selectors.bbarButtonGoBack);
    const devZoneLastPath = sessionStorage.getItem('dev-zone-last-path');

    bbarButtonGoBack.addEventListener('click', event => {
      if (devZoneLastPath) {
        event.preventDefault();
        window.location.href = `${window.location.protocol}//${window.location.hostname}/developer-zone/${devZoneLastPath}`;
      }
    });

    this.nonce = container.dataset.nonce;
    this.postId = container.dataset.postId;

    this.calcContainerPadding();

    addEventListener(
      'resize',
      debounce(() => {
        setTimeout(() => {
          this.calcContainerPadding();
        }, 10);
      }, 100),
    );

    this.steps = [ ...this.block.querySelectorAll(this.selectors.step) ];

    const navButtonPrev = this.block.querySelector(this.selectors.navigationTbarButtonPrev);
    const navButtonNext = this.block.querySelector(this.selectors.navigationTbarButtonNext);
    const bbarButtonPrev = this.block.querySelector(this.selectors.bbarButtonPrev);
    const bbarButtonNext = this.block.querySelector(this.selectors.bbarButtonNext);

    navButtonPrev.addEventListener('click', () => !navButtonPrev.classList.contains(this.classes.navigationTbarButtonHidden) ? this.showStepDelta(-1) : '');
    navButtonNext.addEventListener('click', () => !navButtonNext.classList.contains(this.classes.navigationTbarButtonHidden) ? this.showStepDelta(1) : '');
    bbarButtonPrev.addEventListener('click', () => navButtonPrev.click());
    bbarButtonNext.addEventListener('click', () => navButtonNext.click());

    const navigationItems = [
      ...this.block.querySelectorAll(this.selectors.navigationItem),
    ];

    navigationItems.forEach(navigationItem => {
      navigationItem.addEventListener('click', () => {
        const index = parseInt(navigationItem.dataset.index, 10);

        this.showStep(index);
      });
    });

    addEventListener('popstate', () => {
      this.openPageByLocation();
    });

    this.openPageByLocation();
    this.initSliders();
  }

  initSliders() {
    // eslint-disable-next-line no-new
    this.navigationSlider = new Swiper(this.block.querySelector('.b-user-journey__navigation'), {
      modules: [ Navigation, Pagination, Autoplay ],
      slidesPerView: 3,
      spaceBetween: 0,
      centeredSlides: true,
      allowTouchMove: false,
      breakpoints: {
        1440: {
          slidesPerView: 7,
        },
        720: {
          slidesPerView: 5,
        },
      },
    });
    if (this.currentStep) {
      this.navigationSlider.slideTo(this.currentStep);
    }
  }

  calcContainerPadding() {
    const { block } = this;
    const steps = this.block.querySelector(this.selectors.steps);

    const blockWidth = block.offsetWidth;
    const stepsWidth = steps.offsetWidth;

    const padding = parseInt((blockWidth - stepsWidth) / 2, 10);

    this.block.style.setProperty(
      '--user-journey-navigation-x-padding',
      `${padding}px`,
    );

    const navigation = this.block.querySelector(this.selectors.navigation);

    navigation.classList.add(this.classes.navigationVisible);

    const navigationItemsElementLast = this.block.querySelector(this.selectors.navigationItemLast);

    if (this.itemsWidth() > window.innerWidth) {
      navigationItemsElementLast.classList.add(this.classes.navigationItemLastVisible);
    } else {
      navigationItemsElementLast.classList.remove(this.classes.navigationItemLastVisible);
    }
  }

  itemsWidth() {
    const navigationItems = [
      ...this.block.querySelectorAll(this.selectors.navigationItemReal),
    ];

    return navigationItems.reduce((acc, item) => {
      const { offsetWidth } = item;

      return acc + offsetWidth;
    }, 0);
  }

  openPageByLocation() {
    let { hash } = window.location;

    hash = parseInt(hash.replace('#', ''), 10) || 1;

    if (hash > 0) {
      this.showStep(hash - 1);
      this.currentStep = hash - 1;
    } else {
      this.currentStep = hash;
    }
  }

  showStepDelta(delta) {
    const currentStep = this.steps.find(
      step => !step.classList.contains(this.classes.stepHidden),
    );

    const currentStepIndex = this.steps.indexOf(currentStep);

    let nextStepIndex = currentStepIndex + delta;

    if (nextStepIndex === this.steps.length) {
      nextStepIndex = 0;
    }

    if (nextStepIndex === -1) {
      nextStepIndex = this.steps.length - 1;
    }

    if (nextStepIndex >= 0 && nextStepIndex < this.steps.length) {
      this.showStep(nextStepIndex);
    }
  }

  showStep(index) {
    const currentStep = this.steps.findIndex(
      step => !step.classList.contains(this.classes.stepHidden),
    );

    if (currentStep === index) {
      return;
    }

    if (this.scrollToViewTimeout) {
      clearTimeout(this.scrollToViewTimeout);
    }

    this.steps.forEach(step => step.classList.add(this.classes.stepHidden));

    this.steps[index].classList.remove(this.classes.stepHidden);

    const navigationItems = [
      ...this.block.querySelectorAll(this.selectors.navigationItem),
    ];

    navigationItems.forEach(navigationItem => {
      navigationItem.classList.remove(this.classes.navigationItemActive);

      if (navigationItem.dataset.index === index.toString()) {
        navigationItem.classList.add(this.classes.navigationItemActive);

        if (this.navigationSlider) {
          this.navigationSlider.slideTo(index);
        }

        const navigationMobileTitle = this.block.querySelector(
          this.selectors.navigationMobileTitle,
        );

        const navigationItemTitle = navigationItem.querySelector(
          this.selectors.navigationItemTitle,
        );

        if (navigationItemTitle) {
          navigationMobileTitle.innerHTML = navigationItemTitle.innerHTML;
        }
      }
    });

    history.pushState({}, null, `#${index + 1}`);

    fetch(
      `${window.wp_ajax.url}?action=af_user_journey_store_step&nonce=${
        this.nonce
      }&step_number=${index + 1}&post_id=${this.postId}`,
    );

    const isFirstStep = index === 0;

    const bbarButtonPrev = this.block.querySelector(
      this.selectors.bbarButtonPrev,
    );

    const navigationTbarButtonPrev = this.block.querySelector(
      this.selectors.navigationTbarButtonPrev,
    );

    if (isFirstStep) {
      navigationTbarButtonPrev.classList.add(this.classes.navigationTbarButtonHidden);
      bbarButtonPrev.classList.add(this.classes.navigationBbarButtonHidden);
    } else {
      navigationTbarButtonPrev.classList.remove(this.classes.navigationTbarButtonHidden);
      bbarButtonPrev.classList.remove(this.classes.navigationBbarButtonHidden);
    }

    const isLastStep = index === this.steps.length - 1;

    const bbarButtonNext = this.block.querySelector(
      this.selectors.bbarButtonNext,
    );

    const navigationTbarButtonNext = this.block.querySelector(
      this.selectors.navigationTbarButtonNext,
    );

    if (isLastStep) {
      navigationTbarButtonNext.classList.add(this.classes.navigationTbarButtonHidden);
      bbarButtonNext.classList.add(this.classes.navigationBbarButtonHidden);
    } else {
      navigationTbarButtonNext.classList.remove(this.classes.navigationTbarButtonHidden);
      bbarButtonNext.classList.remove(this.classes.navigationBbarButtonHidden);
    }
  }
}

export default class UserJourney {
  constructor() {
    this.selector = '.b-user-journey';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.wrappers.forEach(wrapper => new UserJourneyItem(wrapper));
  }
}
